import { render, staticRenderFns } from "./EvaluationsOfMyTeamDetailsCoord.vue?vue&type=template&id=0ad06f8d"
import script from "./EvaluationsOfMyTeamDetailsCoord.vue?vue&type=script&lang=js"
export * from "./EvaluationsOfMyTeamDetailsCoord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports